export const PopularProducts = [
    {
        id: 1,
        img: 'bfrainbow.jpg'
    },
    {
        id: 2,
        img: "pinkblack.jpg"
    },
    {
        id: 3,
        img: "blackheart.jpg",
    },
    {
        id: 4,
        img: "BlackandsilverRing.jpg",
    },
    {
        id: 5,
        img: "lockkey.jpg",

    },
    {
        id: 6,
        img: "goldenring.jpg",
    },
    {
        id: 6,
        img: "YinYan.jpg",

    },
    {
        id: 6,
        img: "forever.jpg",

    },

]